<template>
    <component :is="tag" role="popover">
      <component :is="tag" ref="trigger" @click.stop="toggle">
        <slot></slot>
      </component>

      <div ref="popover" :class="popoverClass">
        <div class="tooltip-container placement-bottom"
             :class="{'tooltip-active': isVisible}"
             :style="tooltipStyle"
             @mouseenter="isMouseOver = true"
             @mouseleave="isMouseOver = false">
          <div class="tooltip-tip ">
            <div class="a-tooltip-tip__arrow"></div>
            <div class="tooltip-tip__text">
              <slot name="popover"></slot>
            </div>
          </div>
        </div>
      </div>
    </component>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      },

      popoverClass: {
        type: String
      },

      tag: {
        type: String,
        default: "div"
      }
    },

    data: () => ({
      isVisible: false,
      isMouseOver: false,
      tooltipStyle: undefined
    }),

    created() {
      this._mounted = false;
      window.addEventListener("resize", this.myEventHandler);
    },

    mounted() {
      const popoverNode = this.$refs.popover;
      if (popoverNode) {
        popoverNode.parentNode.removeChild(popoverNode);
      }
    },

    beforeDestroy() {
      this.dispose();
    },

    methods: {
      _updatePosition() {
        const bounds = this.$refs.trigger.getBoundingClientRect();
        this.tooltipStyle = {
          top: (window.scrollY || window.pageYOffset || 0) + bounds.top + bounds.height + 'px',
          left: (window.scrollX || window.pageXOffset || 0) + bounds.left + 'px'
        };
      },

      toggle() {
        if (!this.isVisible) {
          this.show()
        }
        else {
          this.hide()
        }
      },

      show() {
        if (this.isVisible || this.disabled) return;

        if (!this._mounted) {
          const node = document.body.appendChild(this.$refs.popover);
          this._mounted = `popover-wrapper-${Date.now() + Math.random()}`;
          node.id = this._mounted;
        }

        this._updatePosition();

        this._onClickOutside = () => {
          if (!this.isMouseOver) {
            this.hide();
          }
        };

        this._onEscKeyPress = (event) => {
          if (event.keyCode === 27) {
            this.hide()
          }
        };

        window.addEventListener('click', this._onClickOutside);
        window.addEventListener('keydown', this._onEscKeyPress);
        window.addEventListener('resize', this._updatePosition);
        this.isVisible = true;
      },

      hide() {
        if (!this.isVisible) return;

        window.removeEventListener('click', this._onClickOutside);
        window.removeEventListener('keydown', this._onEscKeyPress);
        window.removeEventListener('resize', this._updatePosition);
        this.isVisible = false;
      },

      dispose() {
        this.hide();

        if (this._mounted) {
          const node = document.getElementById(this._mounted);
          node && node.parentNode.removeChild(node);
          this._mounted = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .placement-bottom {
    -webkit-transform: translate(-50%, 25px) ;
    -moz-transform: translate(-50%, 20px);
    -ms-transform: translate(-50%, 20px);
    -o-transform: translate(-50%, 20px);
    transform: translate(-50%, 25px);
  }

  @media only screen and (max-width: 460px) {
    .placement-bottom {
      -webkit-transform: initial;
      -moz-transform: initial;
      -ms-transform: initial;
      -o-transform: initial;
      transform: initial;
    }
  }

  @media only screen and (max-width: 610px) {
    .placement-bottom {
      -webkit-transform: initial;
      -moz-transform: initial;
      -ms-transform: initial;
      -o-transform: initial;
      transform: initial;
    }
  }

  @media only screen and (max-width: 960px) {
    .placement-bottom {
      -webkit-transform: initial;
      -moz-transform: initial;
      -ms-transform: initial;
      -o-transform: initial;
      transform: initial;
    }
  }

  .a-tooltip-tip__arrow {
    position: absolute;
    top: -42px;
    left: calc(50% - 16px);

    width: 32px;
    height: 32px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 16px 10px -17px rgba(0, 0, 0, 0.5);

    &:before {
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      transform: rotate(45deg); /* Не забываем про префиксы */
      top: 24px;
      left: 8px;
      box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.5);
      background: #fff;
    }
  }

  .tooltip-tip__text {
    margin-top: -32px;
  }

  .tooltip-tip {
    width: auto;
    max-width: initial;
  }
</style>
